<template>
  <svg
    width="25"
    height="60%"
    viewBox="0 0 25 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M24.3076 9.1479C24.0569 9.41652 23.7169 9.56744 23.3623 9.56744C23.0077 9.56744 22.6677 9.71835 22.417 9.98698C22.1662 10.2556 22.0254 10.6199 22.0254 10.9998C22.0254 11.3797 22.1662 11.7441 22.417 12.0127C22.6677 12.2813 23.0077 12.4323 23.3623 12.4323C23.7169 12.4323 24.0569 12.5832 24.3076 12.8518C24.5584 13.1204 24.6992 13.4848 24.6992 13.8647V18.3529C23.9066 19.6688 23.3166 20.2494 22.0254 21.0267H3.30859C1.99005 20.2573 1.39508 19.6807 0.634766 18.3529V13.8647C0.634766 13.4848 0.775619 13.1204 1.02634 12.8518C1.27706 12.5832 1.61711 12.4323 1.97168 12.4323C2.32625 12.4323 2.6663 12.2813 2.91702 12.0127C3.16774 11.7441 3.30859 11.3797 3.30859 10.9998C3.30859 10.6199 3.16774 10.2556 2.91702 9.98698C2.6663 9.71835 2.32625 9.56744 1.97168 9.56744C1.61711 9.56744 1.27706 9.41652 1.02634 9.1479C0.775619 8.87927 0.634766 8.51493 0.634766 8.13503V3.64682C1.38615 2.3491 1.96045 1.75232 3.30859 0.972992H22.0254C23.3434 1.64085 23.8534 2.3162 24.6992 3.64682V8.13503C24.6992 8.51493 24.5584 8.87927 24.3076 9.1479Z" fill="#5C53A2"/>
    <rect
      x="9.65918"
      y="7.32458"
      width="2.10564"
      height="3.76007"
      rx="0.4375"
      transform="rotate(-180 9.65918 7.32458)"
      fill="#F1F0FF"
    />
    <rect
      x="9.65918"
      y="12.9647"
      width="2.10564"
      height="3.76007"
      rx="0.4375"
      transform="rotate(-180 9.65918 12.9647)"
      fill="#F1F0FF"
    />
    <rect
      x="9.65918"
      y="18.6049"
      width="2.10564"
      height="3.76007"
      rx="0.4375"
      transform="rotate(-180 9.65918 18.6049)"
      fill="#F1F0FF"
    />
  </svg>
</template>
